import Button from 'react-bootstrap/Button'

import './ButtonTime.scss'

const ButtonTime = ({ time, onClick, disabled, className }) => {
    return (
        <Button onClick={onClick} className={`button-time rounded-1 border-0 ${className}`} disabled={disabled}>
            {time}
        </Button>
    )
}

export default ButtonTime
